import { render, staticRenderFns } from "./account_bank.vue?vue&type=template&id=ecd6f1be&scoped=true&"
import script from "./account_bank.vue?vue&type=script&lang=js&"
export * from "./account_bank.vue?vue&type=script&lang=js&"
import style0 from "./account_bank.vue?vue&type=style&index=0&id=ecd6f1be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecd6f1be",
  null
  
)

export default component.exports